export class ObligationPeriodDto {
  id: string;
  ObligationPeriodName: string;
  ObligationPeriodDays: number;
  SubscriptionUserId: string;
  SubscriberId: string;
  dateCreated: Date;
  dateUpdated?: Date;
  CreatedById: string;
  ModifiedById: string;
  SiteId: string;
  Version: number;
}
